import React from 'react';
import { useGlobalLoader } from '../../src/contexts/GlobalLoaderContext';
import { Loader2 } from 'lucide-react';

export const GlobalLoader: React.FC = () => {
  const { isLoading, message } = useGlobalLoader();

  if (!isLoading) return null;

  return (
    <div
      className="fixed inset-0 bg-black/30 backdrop-blur-md flex items-center justify-center z-50 animate-in fade-in duration-200"
      style={{ zIndex: 9999 }} // Force top layer
    >
      <div className="bg-white/90 backdrop-blur rounded-xl p-8 shadow-2xl flex flex-col items-center gap-4 animate-in zoom-in-50 duration-200 max-w-sm mx-4">
        <Loader2 className="w-12 h-12 text-[#FFD700] animate-spin" />
        <p className="text-gray-800 font-semibold text-lg text-center whitespace-pre-line">
          {message || 'Loading'}
        </p>
      </div>
    </div>
  );
};
